<template>
    <div class="form-group" :id="id">
        <div class="form-row">
            <div
                class="col toggleFilters"
                :class="{ 'is-open': show_more }"
                @click="toggleFilters"
            >
                <!--<my-input class="range-control-input" :label="labels[mainLabel]" readonly :value="placeholder"/> -->
                <span class="range-control-label" :class="{ 'font-weight-bold ' : placeholder }">
                    {{ (placeholder ? placeholder : labels[mainLabel]) | capitalize }}
                </span>
            </div>
        </div>

        <div v-show="show_more" class="range-control-filters">
            <div class="form-group">
                <div class="form-row">
                    <div class="col-6">
                        <my-input
                            :ref="minValueKey"
                            :label="labels[minValueKey]"
                            v-model="min_value"
                            :min="min"
                            secondary
                            @focus="selectRange('min')"
                            @input="formatValue($event, 'min_value')"
                            @keydown.enter.stop.prevent="toggleFilters"
                        />
                        <input :name="minValueKey" type="hidden" v-model="numeric_min_value" />
                    </div>
                    <div class="col-6">
                        <my-input
                            :ref="maxValueKey"
                            :label="labels[maxValueKey]"
                            v-model="max_value"
                            :min="min"
                            secondary
                            @focus="selectRange('max')"
                            @input="formatValue($event, 'max_value')"
                            @keydown.enter.stop.prevent="toggleFilters"
                        />
                        <input :name="maxValueKey" type="hidden" v-model="numeric_max_value" />
                    </div>
                    <div
                        v-if="defaultValues"
                        class="col-12 default-value"
                        @keydown.enter.stop.prevent="toggleFilters"
                        tabindex="0"
                    >
                        <div
                            v-show="show_default_value_min"
                            ref="default_value_min"
                            class="default-value-min"
                        >
                            <ul>
                                <li
                                    v-for="(default_value, key) in defaultValues.values"
                                    v-if="(key >= default_range_min_value) && (key <= default_range_max_value)"
                                    :ref="(min_value == default_value) ? 'default_range_min_selected' : null"
                                    :key="key"
                                    :class="(min_value == default_value) ? 'selected' : ''"
                                    @click="selectDefaultValue(default_value, 'min')"
                                >{{ default_value }} <span v-html="defaultValues.unit"></span></li>
                            </ul>
                        </div>

                        <div 
                            v-show="show_default_value_max"
                            ref="default_value_max"
                            class="default-value-max"
                        >
                            <ul>
                                <li
                                    v-for="(default_value, key) in defaultValues.values"
                                    v-if="(key >= default_range_min_value) && (key <= default_range_max_value)"
                                    :ref="(max_value == default_value) ? 'default_range_max_selected' : null"
                                    :key="key"
                                    :class="(max_value == default_value) ? 'selected' : ''"
                                    @click="selectDefaultValue(default_value, 'max')"
                                >{{ default_value }} <span v-html="defaultValues.unit"></span></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { numberFormat , getNumber} from '../../../helpers/numbers'

export default {
    props: {
        defaultValues: {
            type: Object,
            required: false,
        },

        filters: {
            type: Object,
            required: true,
        },

        labels: {
            type: Object,
            required: true,
        },

        mainLabel: {
            type: String,
            required: true,
        },

        maxValueKey: {
            type: String,
            required: true,
        },

        min: {
            type: String,
            required: false,
        },

        minValueKey: {
            type: String,
            required: true,
        },

        type: {
            type: String,
            required: true,
        },

        unit: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            id: null,
            min_value: null,
            max_value: null,
            placeholder: '',
            previous_values: {
                min_value: null,
                max_value: null
            },
            show_more: false,
            show_default_value_min: true,
            show_default_value_max: false,
        }
    },

    watch: {
        min_value: {
            deep: true,
            handler() {
                this.generatePlaceholder()
            }
        },

        max_value: {
            deep: true,
            handler() {
                this.generatePlaceholder()
            }
        },

        show_more: {
            handler(newValue) {
                if (newValue == false) {
                    this.emitClose()
                } else {
                    this.$nextTick(
                        () => {
                            let minInput = this.$refs[this.minValueKey]
                            if (minInput && minInput.$el) {
                                minInput.$el.children[0].focus()
                            }
                        })
                }
            }
        }
    },

    computed: {
        lang() {
            return this.$root.lang.words
        },

        numeric_min_value() {
            if (this.min_value != null) {
                if (getNumber(this.min_value) > 0) {
                    this.filters[this.minValueKey] = getNumber(this.min_value)
                } else {
                    this.filters[this.minValueKey] = null
                }
            }

            return this.filters[this.minValueKey]
        },

        numeric_max_value() {
            if (this.max_value != null) {
                if (getNumber(this.max_value) > 0) {
                    this.filters[this.maxValueKey] = getNumber(this.max_value)
                } else {
                    this.filters[this.maxValueKey] = null
                }
            }

            return this.filters[this.maxValueKey]
        },

        default_range_min_value() {
            if (this.defaultValues.range[this.filters.type]) {
                return this.defaultValues.range[this.filters.type].min
            } else {
                return this.defaultValues.range.default.min
            }
        },

        default_range_max_value() {
            if (this.defaultValues.range[this.filters.type]) {
                return this.defaultValues.range[this.filters.type].max
            } else {
                return this.defaultValues.range.default.max
            }
        }

    },

    created() {
        this.watchClickOutside()
    },

    methods: {

        numberFormat(number) {
            return numberFormat(number, 0 , ',', '.')
        },

        toggleFilters() {
            window.events.$emit('showRangeInput', { name: this.mainLabel })

            this.show_default_value_min = true
            this.show_default_value_max = false
        },

        formatValue(event, key) {
            let new_key = getNumber(event)

            if (new_key > 0) {
                new_key = new_key > this.min
                    ? new_key
                    :   this.min

                if (new_key == this[key]) {
                    this[key] = event
                }

                this.$nextTick(() => {
                    this[key] = this.numberFormat(new_key)
                })
            }
            else if (event == '') {
                this.emitUpdated()
            }
        },

        generatePlaceholder() {
            let placeholder = ''

            if (this.numeric_min_value && this.numeric_min_value > 0) {
                // placeholder += this.lang.range.from + this.min_value + ' ' + this.unit
                placeholder += this.lang.range.from.replace(':value', this.min_value + ' ' + this.unit)
            }

            if (this.numeric_max_value && this.numeric_max_value > 0) {
                if (placeholder.length == 0) {
                    // placeholder += this.lang.range.up_to
                    placeholder += this.lang.range.up_to.replace(':value', this.max_value + ' ' + this.unit)
                } else {
                    // placeholder += this.lang.range.to
                    placeholder += this.lang.range.to.replace(':value', this.max_value + ' ' + this.unit)
                }

                // placeholder += this.max_value + ' ' + this.unit
            }

            this.placeholder = placeholder
        },

        watchClickOutside() {
            window.addEventListener('click', e => {
                if (this.show_more) {
                    let container = document.getElementById(this.id)

                    if (! container.contains(e.target)) {
                        this.show_more = false
                    }
                }
            })
        },

        checkNumberOrder() {
            if (this.numeric_min_value > this.numeric_max_value && this.numeric_max_value > 0) {
                let min_value = this.min_value

                this.min_value = this.max_value
                this.max_value = min_value
                this.numeric_min_value
                this.numeric_max_value
            }
        },

        emitClose() {
            this.checkNumberOrder()
            this.$emit('closed')
            this.emitUpdated()
        },

        emitUpdated() {
            if (this.previous_values.min_value != this.numeric_min_value || this.previous_values.max_value != this.numeric_max_value) {
                this.$emit('updated')
                
                this.previous_values = {
                    min_value: this.numeric_min_value,
                    max_value: this.numeric_max_value
                }
            }
        },

        selectDefaultValue(default_value, range) {
            if (range == 'min') {
                this.min_value = default_value
                this.scrollDefaultRange('max')

                this.show_default_value_min = false
                this.show_default_value_max = true
            } else {
                this.max_value = default_value
            }
        },

        selectRange(range) {
            this.scrollDefaultRange(range)

            if (range == 'min') {
                this.show_default_value_min = true
                this.show_default_value_max = false
            } else {
                this.show_default_value_min = false
                this.show_default_value_max = true
            }
        },

        scrollDefaultRange(range) {
            this.$nextTick(() => {
                if (this.$refs['default_range_' + range + '_selected'] && this.$refs['default_range_' + range + '_selected'].length) {          
                    this.$refs['default_value_' + range].scrollTop = this.$refs['default_range_' + range + '_selected'][0].offsetTop - this.$refs['default_range_' + range + '_selected'][0].offsetHeight
                } else {
                    this.$refs['default_value_' + range].scrollTop = 0
                }
            })
        }
    },

    mounted() {
        this.id = this._uid

        this.min_value = this.filters[this.minValueKey]
            ? this.numberFormat(this.filters[this.minValueKey])
            : null

        this.max_value = this.filters[this.maxValueKey]
            ? this.numberFormat(this.filters[this.maxValueKey])
            : null

        this.generatePlaceholder()

        window.events.$on('showRangeInput',(event) => {
            if (event.name == this.mainLabel) {
                this.show_more = !this.show_more
            } else {
                this.show_more = false
            }
        })
    }
}
</script>